<template>
    <b-modal
        :id="id"
        :visible="visible"
        :size="size"
        :centered="centered"
        :scrollable="scrollable"
        :hide-header="hideHeader"
        :hide-footer="hideFooter"
        :no-close-on-backdrop="staticBackdrop || busy"
        :no-close-on-esc="staticBackdrop || busy"
        :modal-class="['base-modal', `base-modal-${variant}`, modalClass]"
        :body-class="bodyClass"
        v-bind="$attrs"
        v-on="$listeners"
    >
        <template #modal-header="{ close }">
            <slot name="header" :close="close">
                <div class="base-modal-heading">
                    <h3 :id="`${id}-title`" class="modal-title">{{ title }}</h3>
                    <small v-if="subtitle" class="base-modal-subtitle">{{ subtitle }}</small>
                </div>
                <button
                    v-if="!hideClose"
                    type="button"
                    class="close base-modal-close"
                    :aria-label="$t('close')"
                    :disabled="busy"
                    @click="close()"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </slot>
        </template>

        <slot></slot>

        <template #modal-footer="{ cancel }">
            <slot name="footer" :cancel="cancel">
                <div v-if="$scopedSlots['footer-left']" class="base-modal-footer-left">
                    <slot name="footer-left"></slot>
                </div>
                <button
                    v-if="!hideCancel"
                    type="button"
                    class="btn text-btn style-btn"
                    :disabled="busy"
                    @click="cancel()"
                >
                    {{ cancelText || $t('cancel') }}
                </button>
                <button
                    type="button"
                    class="btn rounded-pill style-btn"
                    :class="`btn-${okVariant}`"
                    :disabled="okDisabled || busy"
                    @click="$emit('ok')"
                >
                    <span v-if="busy" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    {{ okText || $t('save') }}
                </button>
            </slot>
        </template>
    </b-modal>
</template>

<script>
export default {
    name:         'base-modal',
    inheritAttrs: false,
    model:        {
        prop:  'visible',
        event: 'change'
    },
    props: {
        id: {
            type:     String,
            required: true
        },
        visible: {
            type:    Boolean,
            default: false
        },
        title: {
            type:    String,
            default: ''
        },
        subtitle: {
            type:    String,
            default: ''
        },
        variant: {
            type:      String,
            default:   'default',
            validator: value => ['default', 'centered'].includes(value)
        },
        size: {
            type:      String,
            default:   'md',
            validator: value => ['sm', 'md', 'lg', 'xl'].includes(value)
        },
        centered: {
            type:    Boolean,
            default: true
        },
        scrollable: {
            type:    Boolean,
            default: false
        },
        staticBackdrop: {
            type:    Boolean,
            default: false
        },
        hideHeader: {
            type:    Boolean,
            default: false
        },
        hideFooter: {
            type:    Boolean,
            default: false
        },
        hideClose: {
            type:    Boolean,
            default: false
        },
        hideCancel: {
            type:    Boolean,
            default: false
        },
        okText: {
            type:    String,
            default: ''
        },
        cancelText: {
            type:    String,
            default: ''
        },
        okVariant: {
            type:      String,
            default:   'primary',
            validator: value => ['primary', 'danger'].includes(value)
        },
        okDisabled: {
            type:    Boolean,
            default: false
        },
        busy: {
            type:    Boolean,
            default: false
        },
        modalClass: {
            type:    [String, Array, Object],
            default: ''
        },
        bodyClass: {
            type:    [String, Array, Object],
            default: ''
        }
    }
};
</script>
